
import { useState } from 'react';
import { useToast } from '@/hooks/use-toast';
import { supabase } from '@/integrations/supabase/client';
import { User } from '@/types/auth';

export function useProfile() {
  const { toast } = useToast();
  const [updating, setUpdating] = useState(false);

  const updateProfile = async (user: User | null, data: { username?: string, avatar_url?: string }) => {
    if (!user) {
      throw new Error("User not authenticated");
    }
    
    try {
      setUpdating(true);
      const { error } = await supabase
        .from('profiles')
        .update(data)
        .eq('id', user.id);

      if (error) throw error;
      
      toast({
        title: "Profile updated",
        description: "Your profile information has been updated.",
      });
    } catch (error: any) {
      toast({
        title: "Error updating profile",
        description: error.message || "Failed to update profile",
        variant: "destructive",
      });
      throw error;
    } finally {
      setUpdating(false);
    }
  };

  return { updateProfile, updating };
}
